import React from 'react';


const About = () => {
    return (
        <>
            <h1 className="mt-5 pt-5 text-center">About</h1>
        </>

    )
}



export default About